import React from 'react';
import { Route, Routes } from 'react-router-dom';
import UpdatePassword from '../pages/UpdatePassword/UpdatePassword';
import { RESET_PASSWORD } from './constants';

const PublicRouter = (): JSX.Element => {
  return (
    <Routes>
      <Route path={`${RESET_PASSWORD}`} element={<UpdatePassword />} />
    </Routes>
  );
};

export default PublicRouter;
